export const SCIENTIFIC_OBJECT_TYPES = ['MOLECULE', 'PROTEIN', 'GENE', 'VARIANT', 'TRANSCRIPT', 'PEPTIDE'] as const;

export type ScientificObjectType = (typeof SCIENTIFIC_OBJECT_TYPES)[number];

export function parseScientificObjectType(value: string): ScientificObjectType | null {
  const normalized = value.toUpperCase();
  return SCIENTIFIC_OBJECT_TYPES.find((type) => type === normalized) ?? null;
}

export function scientificObjectTypePath(type: ScientificObjectType): string {
  return type.toLowerCase();
}
